import { useEffect, useState } from "react";
import { api } from "../lib/api";

const Chips = ({ label, items, testid }) => (
  <div className="min-w-0" data-testid={testid}>
    <p className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</p>
    <div className="mt-2 flex flex-wrap gap-1.5">
      {items.length ? items.map((i) => (
        <span key={i.name} className="max-w-[220px] truncate rounded-full border border-white/10 bg-white/[0.03] px-2.5 py-1 text-xs capitalize text-zinc-300" title={i.name}>
          {i.name} <span className="text-[#D4AF37]">{i.count}</span>
        </span>
      )) : <span className="text-xs text-zinc-600">—</span>}
    </div>
  </div>
);

export const LiveVisitors = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let live = true;
    const load = () => api.get("/admin/live").then(({ data }) => live && setD(data)).catch(() => {});
    load();
    const id = setInterval(load, 10000);
    return () => { live = false; clearInterval(id); };
  }, []);

  return (
    <div className="mb-6 grid grid-cols-1 gap-5 rounded-2xl border border-[#25D366]/25 bg-[#0d1410] p-5 md:grid-cols-[auto_1fr_1fr_1fr] md:items-center" data-testid="live-visitors">
      <div className="flex items-center gap-4">
        <span className="relative flex h-3 w-3">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-70" />
          <span className="relative inline-flex h-3 w-3 rounded-full bg-[#25D366]" />
        </span>
        <div>
          <p className="text-xs uppercase tracking-widest text-zinc-500">On site right now</p>
          <p className="font-serif text-4xl font-bold text-white" data-testid="live-count">{d ? d.count : "…"}</p>
          <p className="text-[11px] text-zinc-400" data-testid="live-updated">Auto-updates every 10s · active in last {d?.window_seconds || 60}s</p>
        </div>
      </div>
      <Chips label="Pages" items={d?.pages || []} testid="live-pages" />
      <Chips label="Countries" items={d?.countries || []} testid="live-countries" />
      <Chips label="Devices" items={d?.devices || []} testid="live-devices" />
    </div>
  );
};
